jQuery(document).ready(function($){

    fakeUploadButtonInit();
   
});



jQuery(document).on('gform_post_render', function(){
    fakeUploadButtonInit()
});


function fakeUploadButtonInit(){

    $ = jQuery;
    var file_input = $('.gform_wrapper input[type="file"]');
    var label;

    if (file_input.closest('li').find('.gform_delete').length > 0){
        label = file_input.closest('li').find('.ginput_preview strong').text();
    }

    else{
        label = file_input.closest('li').find('.gfield_label').text();

    }

    label = label.replace("*", "");

    file_input.closest('li').append('<div class="fake-file-border"><span class="fake-file-button-text">'+label+'</span><span class="upload-file-button fas fa-plus"></span></div>');

    file_input.on('change', function(){
        var fileName = $(this).val().split('\\').pop();

        $('.fake-file-button-text').text(fileName);
    });

    $('.who-we-are-page select').select2();
} 